const config = {
  configEndpoints: {
    baseEndpoint: "https://api.uat.hub.affinity.io/partner",
  },
};
export default config;
